import { render, staticRenderFns } from "./detail_bill.vue?vue&type=template&id=305a9d66&"
import script from "./detail_bill.vue?vue&type=script&lang=ts&"
export * from "./detail_bill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports